import './PaperSize.less';

import classNames from 'classnames';

export type PaperSizeProps = {
  width: number;
  height: number;
};

const sizeRatio = 76 / 11;

export const PaperSize = (props: PaperSizeProps) => {
  return (
    <div className="revx-paper-size">
      <div
        className={classNames('revx-paper-size-inner')}
        style={{
          width: props.width * sizeRatio,
          height: props.height * sizeRatio,
        }}
      ></div>
    </div>
  );
};
